// The pick variant: a pipeline build whose output is the pattern coordinate at each pixel (`main.pick`), read back one pixel at a time. Node-safe: the lab builds it too.
import light from '../shaders/pipeline/light.glsl.js'
import main from '../shaders/pipeline/main.glsl.js'

const WRAP = 4096

/** `fragment` (a pipeline variant's source, surfaced or not) as the pick build for `axis` (0 across the bands, 1 along). */
export const pickFragment = (fragment, axis) => {
	if (!fragment.includes(main.pick.at)) throw new Error('pick build: fragment lacks the pipeline main')
	let out = fragment.replace(/^(#version[^\n]*\n)/, `$1#define PICK ${axis}\n`).replace(main.pick.at, main.pick.glsl)
	for (const { at, glsl } of light.pick) {
		if (!out.includes(at)) throw new Error('pick build: fragment lacks the rows stage')
		out = out.replace(at, at + glsl)
	}
	return out
}

/** A pick pixel (RGBA8) → its cell coordinate, unwrapped to the one nearest `near`; null off the pattern. */
export const decodePick = ([r, g, b, a], near = 0) => {
	if (a < 255) return null
	const whole = r * 16 + (g >> 4)
	const frac = (g & 15) * 256 + b
	const v = whole + (frac + 0.5) / WRAP
	return v + Math.round((near - v) / WRAP) * WRAP
}

/** The pixel `decodePick` reads as `v` (the shader's packing, for tests and the lab). */
export const encodePick = v => {
	const whole = ((Math.floor(v) % WRAP) + WRAP) % WRAP
	const frac = Math.min(Math.floor((v - Math.floor(v)) * WRAP), WRAP - 1)
	return [whole >> 4, (whole & 15) * 16 + (frac >> 8), frac & 255, 255]
}
